import Vue from 'vue'
Vue.use(Vuex)
import Vuex from 'vuex'
import * as mut from '../mut-types.js'
let guestSettings = localStorage.getItem('guest-settings')
try {
  guestSettings = JSON.parse(guestSettings)
  if(typeof guestSettings !== 'object' || null === guestSettings) {
    throw ""
  }
} catch(e) {
  guestSettings = {}
}
function getUntilDaysAgo(array, daysN) {
  let day = 60 * 60 * 24
  let now = new Date().getTime()
  return array.filter(t => t + (day * daysN) > now)
}
function getSearchesTs() {
  const t2 = "search_ts"
  let ts = localStorage.getItem(t2)
  let l
  try {
    l = JSON.parse(ts)
    if(!Array.isArray(l)) {
      l = []
    }
  } catch(e) {
    l = []
  }
  l = getUntilDaysAgo(l, 7)
  localStorage.setItem(t2, JSON.stringify(l))
  return l
}
const defaultSettings = {
  displayHistory: false,
  displayBookmarks: false,
  displayWeather:true,
  displayMail:true,
  displayCalendar:true,
  displayTodo:true,
  displayQuotes:false,
  displayShortcuts:false,
  displayBkButtons:true,
  displayTime:true,
  displayVideos:true,
  displayGames:true,
  displayMusic:false,
  displayNews:true,
  displayUtilities:true,
  displayMediaGuides:false,
  displayTwitter: true,
  displayShopping: true,
  displayBackgroundChanger: true,
  displayPhotolab: true,
  displayPinterest: true,
  displayShareIcons: true,
  displayGreeting: true,
  displayFaren: localStorage.getItem("displayFaren") !== "false"
}
const store = new Vuex.Store({
  state: {
    dev: process.env.NODE_ENV !== 'production',
    defaultSettings,
    settings: Object.assign({}, defaultSettings, guestSettings),
    user: null,
    widgetsStatus: {
      twitter: false
    },
    cleanMode: 0,
    yahooSearchesList: getSearchesTs(),
    isGuest: !!localStorage.getItem('isGuestUser') || localStorage.getItem('googlePermission') !== 'true',
    backgroundImage: {},
    facebookGallery: null,
    fbLoggedIn: true,
    country_iso: null,
    shortcuts: [],
    guestLogin: null,
    isNewUser: null,
    isMobile: null,
    news_topics: null,
    news_topics_all: null,
    onBackBtn: null,
    tryAuth: true
  },
  mutations: {
    [mut.SET_SETTINGS] (state, payload) {
      Object.assign(state.settings, payload)
      // state.settings = payload
    },
    [mut.SET_USER] (state, payload) {
      state.user = payload
    }
  }
})


export default store



// WEBPACK FOOTER //
// ./src/store/index.js